// extracted by css-extract-rspack-plugin
export default {"Dialog":"CheckStatusDialog-module__Dialog__u6VYN_4","Dialog_Body":"CheckStatusDialog-module__Dialog_Body__FY0UueB","Box":"CheckStatusDialog-module__Box__oxIDnvK"};